var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tag as AntdTag } from "antd";
import { purple7, purple9, magenta7, magenta9, cyan8, cyan10, volcano7, red9, blue7, blue9 } from "../../assets/variables";
import { EAppEnv } from "@timeedit/types/lib/enums/appEnv.enum";
import "./Tag.scss";
/**
 * Renders a Dev tag with specific styling.
 */
const DevTag = () => (_jsx(Tag, { style: { backgroundColor: purple7, borderColor: purple9, color: "white" }, children: "Dev" }));
/**
 * Renders a Beta tag with specific styling.
 */
const BetaTag = () => (_jsx(Tag, { style: { backgroundColor: magenta7, borderColor: magenta9, color: "white" }, children: "Beta" }));
/**
 * Renders a Staging tag with specific styling.
 */
const StagingTag = () => (_jsx(Tag, { style: { backgroundColor: cyan8, borderColor: cyan10, color: "white" }, children: "Staging" }));
/**
 * Renders a Test tag with specific styling.
 */
const TestTag = () => (_jsx(Tag, { style: { backgroundColor: volcano7, borderColor: red9, color: "white" }, children: "Test" }));
/**
 * Renders a Demo tag with specific styling.
 */
const DemoTag = () => (_jsx(Tag, { style: { backgroundColor: blue7, borderColor: blue9, color: "white" }, children: "Demo" }));
/**
 * Displays the current environment based on the appEnv prop.
 * It helps to clearly indicate the environment for implementation and testing purposes,
 * preventing confusion and mistakes when working with different environments.
 * Note: No tag is rendered for production as it should not have an environment tag.
 */
export const EnvTag = ({ appEnv }) => {
    if (appEnv == EAppEnv.BETA)
        return _jsx(BetaTag, {});
    if (appEnv == EAppEnv.DEVELOPMENT)
        return _jsx(DevTag, {});
    if (appEnv == EAppEnv.STAGING)
        return _jsx(StagingTag, {});
    if (appEnv == "test")
        return _jsx(TestTag, {});
    if (appEnv == "demo")
        return _jsx(DemoTag, {});
    return null;
};
/**
 * Display a tag with an optional dashboard border.
 * It can be used to highlight, categorize, filter or visualize status of items.
 *
 * Note: Storybook doesn't display all controls for this component,
 * but all props available in the [AntD Tag](https://ant.design/components/tag/) component are supported.
 */
export const Tag = (props) => {
    const { className, dashed } = props, rest = __rest(props, ["className", "dashed"]);
    return (_jsx(AntdTag, Object.assign({ "data-testid": "tag" }, rest, { className: `${className} ${dashed ? "ant-tag--dashed" : ""}` })));
};
Tag.CheckableTag = AntdTag.CheckableTag;
Tag.EnvTag = EnvTag;
export default Tag;
